export const AVM = 'avm'
export const WIN = 'win'
export const REFI = 'refi'
export const AIRBNB = 'airbnb'
export const CASHOUT = 'cashout'
export const NET_WORTH = 'net_worth'
export const MAP_PANNED = 'map_panned'
export const MAP_ZOOM_IN = 'zoomed_in'
export const MAP_ZOOM_OUT = 'zoomed_out'
export const TOTAL_COST_ANALYSIS = 'tca'
export const FILTER_SQFT_MIN = 'sqft_min'
export const FILTER_SQFT_MAX = 'sqft_max'
export const FILTER_PRICE_MAX = 'price_max'
export const FILTER_PRICE_MIN = 'price_min'
export const FILTER_BED_MIN = 'bedroom_min'
export const FILTER_BATH_MIN = 'bathroom_min'
export const FILTER_PROPERTY_TYPE = 'home_type'
export const FILTER_YR_MIN = 'construction_year_min'
export const FILTER_YR_MAX = 'construction_year_max'
export const CUSTOM_MARKET_ANALYSIS = 'cma'
export const SHOULD_I_SELL = 'should_i_sell'
export const INSTANT_OFFER = 'instant_offer'
export const PURCHASE_POWER = 'purchase_power'
export const HOME_INSURANCE = 'home_insurance'
export const PMI_QUICK_CHECK_NO = 'no'
export const PMI_QUICK_CHECK_YES = 'yes'
export const PMI_QUICK_CHECK_UNSURE = 'unsure'
export const PMI_INDICATED_SOON = 'soon'
export const PMI_INDICATED_NOW = 'maybe_now'
export const PMI_INDICATED_NOT_YET = 'not_yet'
export const PRIVATE_MORTGAGE_INSURANCE = 'pmi'
export const CLIENT_ADDED_LOAN = 'added_loan'
export const CLIENT_UPDATED_LOAN = 'updated_loan'
export const CLIENT_SCHEDULED_SHOWING = 'showing'
export const CLIENT_REQUESTED_PREQUAL = 'prequal'
export const CLIENT_UPDATED_BUDGET = 'updated_budget'
export const CLIENT_CONFIRMED_LOAN = 'confirmed_loan'
export const CLIENT_UPDATED_PRICE_POINT = 'updated_price_point'
export const CLIENT_UPDATED_TIMELINE = 'updated_buying_timeline'
export const CLIENT_UPDATED_LOAN_BALANCE = 'updated_loan_balance'
export const CUSTOMER_TYPE_LO = 'loan_officer'
export const CUSTOMER_TYPE_IA = 'insurance_agent'
export const CUSTOMER_TYPE_REA = 'real_estate_agent'
export const REVERSE_MORTGAGE = 'reverse_mortgage'
export const TUNED_VALUE_INCREASE = 'tune_increase'
export const TUNED_VALUE_DECREASE = 'tune_decrease'
export const PRINCIPAL_INTEREST = 'principal_interest'
export const PAY_EXTRA_PRINCIPAL = 'pay_extra_principal'
export const SORT_LISTINGS_BY_PRICE_LOW = 'sort_price_low'
export const SORT_LISTINGS_BY_PRICE_HIGH = 'sort_price_high'
export const SORT_LISTINGS_BY_SQFT_LARGE = 'sort_sqft_largest'
export const SORT_LISTINGS_BY_SQFT_SMALL = 'sort_sqft_smallest'
export const HOME_IMPROVEMENT = 'home_improvement'
export const PRINCIPAL_PAYMENT = 'principal_payment'
export const MONTHLY_REVENUE = 'monthly_revenue'
export const NIGHTLY_RATE = 'nightly_rate'
export const NUMBER_OF_NIGHTS = 'number_of_nights'
export const BASIC_OR_FANCY = 'basic_or_fancy'
export const SELDOM_OR_OFTEN = 'seldom_or_often'
export const EMERGENCY_RESERVE = 'emergency_fund'
export const HOME_IMPROVEMENTS = 'home_improvements'
export const ADD_SPACE = 'add_space'
export const STUDENT_DEBT = 'student_loans'
export const ELIMINATE_CREDIT_CARD_DEBT = 'credit_card_debt'
export const SOLAR_PANELS = 'solar_panels'
export const EUROTRIP = 'european_vacation'
export const EXPLORE_INVESTMENTS = 'new_investments'
export const SEARCH_HOMES = 'search_homes'
export const FAVORITE_LISTINGS = 'favorite_listings'
export const SAVED_SEARCHES = 'saved_searches'
export const EXPLORE_MARKETS = 'explore_markets'
export const BUYING_REPORT = 'buying_report'
export const YOU_MIGHT_PAY = 'you_might_pay'
export const POSSIBLE_GAIN_OR_LOSS = 'possible_gain_or_loss'
export const OFFER_SLIDER = 'offer_slider'
export const GROWTH_SLIDER = 'growth_slider'
export const RENTAL_NIGHTS = 'rental_nights'
export const RENTAL_INCOME = 'rental_income'
export const USEFUL_REPLY = 'useful_reply'
export const NOT_USEFUL_REPLY = 'not_useful_reply'
export const LOW_INSURANCE_RISK = 'low'
export const MEDIUM_INSURANCE_RISK = 'medium'
export const HIGH_INSURANCE_RISK = 'high'
export const ADJUST_HOME_INSURANCE_POLICY_START_DATE = 'adjust_policy_date'
export const CONFIRM_INSURANCE_DETAILS = 'confirm_insurance'
export const MORE_INFO_ON_HOME_INSURANCE = 'more_info'
export const SNOOZE_INSURANCE_DETAILS = 'snooze_insurance'
export const UPDATE_HOME_INSURANCE_POLICY = 'update_policy_details'
